import { Flex, Loader, Text } from "@mantine/core";
import LogoutButton from "components/LogoutButton";
import { useTranslation } from "react-i18next";
import useOryAuth from "./useOryAuth";

const Auth = () => {
  const { t } = useTranslation();
  const { isLoginFailed } = useOryAuth();

  if (isLoginFailed) {
    return (
      <Flex
        direction={"column"}
        justify={"center"}
        align={"center"}
        className="w-screen h-screen"
      >
        <Text data-testid="login-fail" className="text-2xl">
          {t("noAccount")}
        </Text>
        <Text>{t("contactAdmin")}</Text>
        <LogoutButton />
      </Flex>
    );
  }

  return (
    <Flex justify={"center"} align={"center"} className="w-screen h-screen">
      <Loader data-testid="loader" />
    </Flex>
  );
};

export default Auth;
